var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.104,
    height: 21.093,
    viewBox: "0 0 24.104 21.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "triangle-exclamation-solid",
    d: "M12.088,32a1.88,1.88,0,0,1,1.624.932l10.17,17.326a1.882,1.882,0,0,1-1.624,2.834H1.918A1.882,1.882,0,0,1,.294,50.258l10.17-17.326A1.88,1.88,0,0,1,12.088,32Zm0,6.026a1.127,1.127,0,0,0-1.13,1.13V44.43a1.13,1.13,0,1,0,2.26,0V39.156A1.127,1.127,0,0,0,12.088,38.026Zm1.507,10.546a1.507,1.507,0,1,0-1.507,1.507A1.507,1.507,0,0,0,13.595,48.573Z",
    transform: "translate(-0.037 -32)",
    fill: "#9F555D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarning);
export default __webpack_public_path__ + "static/media/alertWarning.35f6bdbe1cc2e808775c08118c503496.svg";
export { ForwardRef as ReactComponent };